import { mockComments } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            读者评价
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            听听真实读者怎么说，千万漫友的共同选择
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mockComments.map((comment, idx) => (
            <div
              key={idx}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-semibold text-foreground-950">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.date}</div>
                </div>
                <div className="ml-auto flex items-center gap-0.5">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i
                      key={i}
                      className={`text-xs ${i < comment.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
                    ></i>
                  ))}
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {comment.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}